import React from "react";
import { AiOutlinePercentage } from "react-icons/ai";
import PhoneInput from "react-phone-number-input";
import { acceptedPaymentMethods, placeTypes } from "../../../constants/data";
import { useTranslation } from "react-i18next";
import { usePlaceAutocomplete } from "../usePlaceAutocomplete ";
import LocationField from "../LocationField";

interface PlaceFormProps {
    formData: any;
    setFormData: React.Dispatch<React.SetStateAction<any>>;
    subCategories: any[];
    errors: any;
}

const PlaceForm: React.FC<PlaceFormProps> = ({ formData, setFormData, subCategories, errors }) => {
    const { t,i18n } = useTranslation();
    const locationEn = usePlaceAutocomplete("en");
    const locationAr = usePlaceAutocomplete("ar");


    // Handle input changes
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    };

    //handle add payment method accepted by place 
const handlePaymentMethodChange = (id: number) => {
    const methods: number[] = formData.paymentMethod || [];

    if (methods.includes(id)) {
        setFormData({
            ...formData,
            paymentMethod: methods.filter((paymentMethod) => paymentMethod !== id),
        });
    } else {
        setFormData({
            ...formData,
            paymentMethod: [...methods, id],
        });
    }
};



    return (
        <div className="w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">

                {/* Place Name EN */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("place-name")}</label>
                    <input
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="input-field px-4"
                    />
                    {errors.title && <p className="text-red-500 text-sm">{errors.title}</p>}
                </div>

                {/* Place Name AR */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("place-nameAr")}</label>
                    <input
                        name="titleAr"
                        value={formData.titleAr}
                        onChange={handleChange}
                        className="input-field px-4"
                    />
                    {errors.titleAr && <p className="text-red-500 text-sm">{errors.titleAr}</p>}
                </div>

                {/* Email */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("email")}</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="input-field px-4"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                </div>

                {/* Phone Inputs */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("number")} 1</label>
                    <PhoneInput
                        international
                        defaultCountry="LY"
                        value={formData.phoneNumber1}
                        onChange={(value) => setFormData({ ...formData, phoneNumber1: value })}
                        className="phone-input input-field px-4"
                    />
                    {errors.phoneNumber1 && <p className="text-red-500 text-sm">{errors.phoneNumber1}</p>}
                </div>

                <div>
                    <label className="block text-gray-600 mb-1">{t("number")} 2</label>
                    <PhoneInput
                        international
                        defaultCountry="LY"
                        value={formData.phoneNumber2}
                        onChange={(value) => setFormData({ ...formData, phoneNumber2: value })}
                        className="phone-input input-field px-4"
                    />
                    {errors.phoneNumber2 && <p className="text-red-500 text-sm">{errors.phoneNumber2}</p>}
                </div>

                {/* Location Input */}
                <LocationField
                    label={t("location")}
                    value={formData.location}
                    placeholder="Enter city"
                    error={errors.location}
                    autocomplete={locationEn}
                    onSelect={(val) => {
                        setFormData({ ...formData, location: val });
                    }}
                    onChange={(val) => {
                        setFormData({ ...formData, location: val });
                    }}
                />

                {/* Location AR  */}
                <LocationField
                    label={t("locationAr")}
                    value={formData.locationAr}
                    placeholder="أدخل المدينة"
                    error={errors.locationAr}
                    autocomplete={locationAr}
                    onSelect={(val) => {
                        setFormData({ ...formData, locationAr: val });
                    }}
                    onChange={(val) => {
                        setFormData({ ...formData, locationAr: val });
                    }} />


                {/* Type */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("type")}</label>
                    <select
                        name="type"
                        value={formData.type}
                        onChange={handleChange}
                        className="input-field px-4"
                    >
                        {placeTypes.map((placeType) => (
                            <option key={placeType.id} value={placeType.value}>
                                {placeType.title_en}
                            </option>
                        ))}
                    </select>
                </div>

                {/* SubCategory */}
                <div>
                    <label className="block text-gray-600 mb-1">{t("select-subCategory")}</label>
                    <select
                        name="subCategoryId"
                        value={formData.subCategoryId}
                        onChange={handleChange}
                        className="input-field px-4"
                    >
                        <option disabled value={0}>Select subCategory</option>
                        {subCategories?.map((subCategory: any) => (
                            <option key={subCategory.id} value={subCategory.id}>{subCategory.title}</option>
                        ))}
                    </select>
                </div>
                {/* number of rooms and number of halls for subcategoy */}
                {formData?.type === "Stay" && Number(formData?.subCategoryId) !== 1 &&
                    <>
                        <div>
                            <label className="block text-gray-600 mb-1">
                                {t("number-of-rooms")}
                            </label>
                            <input name="numberOfRooms" type="number" value={formData.numberOfRooms || ""} onChange={handleChange} className="input-field px-4" />
                            {errors.numberOfRooms && <p className="text-red-500 text-sm">{errors.numberOfRooms}</p>}
                        </div>
                        <div>
                            <label className="block text-gray-600 mb-1">
                                {t("number-of-halls")}
                            </label>
                            <input name="numberOfHalls" type="number" value={formData.numberOfHalls || ""} onChange={handleChange} className="input-field px-4" />
                            {errors.numberOfHalls && <p className="text-red-500 text-sm">{errors.numberOfHalls}</p>}
                        </div>
                    </>
                }
                {formData?.type === "Hall" &&

                    <div>
                        <label className="block text-gray-600 mb-1">
                            {t("number-of-people")}
                        </label>
                        <input name="numberOfPeoples" type="number" value={formData.numberOfPeoples || ""} onChange={handleChange} className="input-field px-4" />
                        {errors.numberOfPeoples && <p className="text-red-500 text-sm">{errors.numberOfPeoples}</p>}
                    </div>

                }
                {/* Price */}
                <div>
                    <label className="block text-gray-600 mb-1">
                        {formData?.type === "Hall" ? t("price-with-LYD") + " " + t("per-morning") : t("price-with-LYD") + t("per-night")}
                    </label>
                    <input name="price" type="number" value={formData.price} onChange={handleChange} className="input-field px-4" />
                    {errors.price && <p className="text-red-500 text-sm">{errors.price}</p>}
                </div>
                {formData?.type === "Hall" && (
                    <div>
                        <label className="block text-gray-600 mb-1">
                            {t("price-with-LYD") + " " + t("per-afternoon")}
                        </label>
                        <input name="priceNight" type="number" value={formData.priceNight} onChange={handleChange} className="input-field px-4" />
                        {errors.priceNight && <p className="text-red-500 text-sm">{errors.priceNight}</p>}
                    </div>
                )}

                {/* Discount */}
                <div className="">
                    <label className="block text-gray-600 mb-1">
                        {formData?.type === "Hall" ? t("discount-per-morning") : t("discount")}
                    </label>
                    <div className="relative input-field">
                        <input name="discountPercentage"
                            type="number"
                            value={formData.discountPercentage === null ? "" : formData.discountPercentage}
                            onChange={handleChange}
                            placeholder="0"
                            className=" focus:outline-none ps-5" />
                        <AiOutlinePercentage className="absolute right-2 top-1/2 transform -translate-y-1/2 text-textSecond pointer-events-none" />
                    </div>
                </div>

                {formData?.type === "Hall" && (
                    <div className="">
                        <label className="block text-gray-600 mb-1">

                            {t("discount-per-afternoon")}
                        </label>
                        <div className="relative input-field">
                            <input name="discountNightPercentage"
                                type="number"
                                value={formData.discountNightPercentage === null ? "" : formData.discountNightPercentage}
                                onChange={handleChange}
                                placeholder="0"
                                className=" focus:outline-none ps-5" />
                            <AiOutlinePercentage className="absolute right-2 top-1/2 transform -translate-y-1/2 text-textSecond pointer-events-none" />
                        </div>
                    </div>
                )}
                

                <div className="flex items-end pb-2 gap-2">
                    <input type="checkbox" name="isPopular" checked={formData.isPopular || false} onChange={handleChange} className="w-5 h-5" />
                    <label className="text-gray-600">{t("is-popular")}</label>
                </div>
                {formData.isPopular && (
                    <div>
                        <label className="block text-gray-600 mb-1">
                            {t("number-of-place")}
                        </label>
                        <input name="number" type="number" value={formData.number || ""} onChange={handleChange} className="input-field px-4" />
                        {errors.number && <p className="text-red-500 text-sm">{errors.number}</p>}
                    </div>)}
            </div>
            {/* Payment Methods */}
                <div className=" md:col-span-2 mb-5">
                    <label className="block text-gray-600 mb-2">
                        {t("accepted-payment-methods")}
                    </label>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {acceptedPaymentMethods.map((method) => (
                            <label
                                key={method.key}
                                className="flex items-center gap-2 border rounded-lg p-3 cursor-pointer hover:bg-gray-50"
                            >
                                <input
                                    type="checkbox"
                                    checked={formData.paymentMethod?.includes(method.key)}
                                    onChange={() => handlePaymentMethodChange(method.key)}
                                    className="w-4 h-4"
                                />
                                <span className="text-sm text-gray-700">
                                    {i18n.language === "ar" ? method.label_ar : method.label_en}
                                </span>
                            </label>
                        ))}
                    </div>

                    {errors.paymentMethod && (
                        <p className="text-red-500 text-sm mt-1">
                            {errors.paymentMethods}
                        </p>
                    )}
                </div>
            {/* Details */}
            <div className=' '>
                <label className="block text-gray-600 mb-1">{t("details")}</label>
                <textarea name="details"
                    value={formData.details}
                    onChange={handleChange}
                    placeholder={t("details")}
                    className="input-field px-4 h-28 resize-none" />
                {errors.details && <p className="text-red-500 text-sm">{errors.details}</p>}
            </div>
            <div className=' '>
                <label className="block text-gray-600 mb-1">
                    {t("detailsAr")}
                </label>
                <textarea name="detailsAr" value={formData.detailsAr} onChange={handleChange} placeholder={t("detailsAr")} className="input-field px-4 h-28 resize-none" />
                {errors.detailsAr && <p className="text-red-500 text-sm">{errors.detailsAr}</p>}
            </div>
        </div>


    );
};

export default PlaceForm;
